module.exports = __webpack_public_path__ + "static/media/example-csv.35570f2f.csv";